import styled from 'styled-components';
import React, { useEffect } from 'react';
import { Close as CloseIcon } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog as MaterialDialog, Grid, Portal } from '@material-ui/core';

import useMobile from '@/services/hooks/useMobile';
import { SetToastPortalWrapper } from '@/store/toast/actions';
import { SetEmailMsgid } from '@/store/emails/actions';
import { ApplicationState } from '@/store';

import ContactEventHistory from './index';
import { StyledProps } from './ContactEventHistoryInterface';
import { useHistoryBackActionContext } from '@/services/hooks/useHistoryBackAction';

const CloseIconContainer = styled.div<StyledProps>`
    width: 100%;
    height: ${({ isMobile }): number => (isMobile ? 64 : 68)}px;
    svg {
        top: ${({ isMobile }): number => (isMobile ? 22 : 24)}px;
        right: ${({ isMobile }): number => (isMobile ? 16 : 24)}px;
        position: absolute;
        cursor: pointer;
    }
`;

const ContentContainer = styled.div`
    padding: 0px 16px;
`;

const ContactEventHistoryOverlay = (): JSX.Element => {
    const dispatch = useDispatch();
    const msgId = useSelector((state: ApplicationState) => state.emails.msgId);
    const isMobile = useMobile();
    const maxWidth = isMobile ? '' : 1170;
    const historyBackAction = useHistoryBackActionContext();

    useEffect(() => {
        dispatch(SetToastPortalWrapper(true));

        historyBackAction?.pushBackCallback(handleCloseOverlay) 
        return () => {
            dispatch(SetToastPortalWrapper(false));
        };
    }, []);

    const handleCloseOverlay = () : boolean => {
        dispatch(SetEmailMsgid(null))
        return true;
    }
    const clickCloseButton = () => {
        historyBackAction.popAndExecuteBackCallback();
    }

    return (
        <Portal>
            <MaterialDialog open={true} fullScreen={true}>
                <div>
                    <CloseIconContainer isMobile={false}>
                        <CloseIcon fontSize={'large'} onClick={clickCloseButton} />
                    </CloseIconContainer>
                    <ContentContainer>
                        <Grid container justifyContent="center">
                            <Grid item xs={12} sm={12} style={{ maxWidth, paddingBottom: 16 }}>
                                <ContactEventHistory msgId={msgId} />
                            </Grid>
                        </Grid>
                    </ContentContainer>
                </div>
            </MaterialDialog>
        </Portal>
    );
};

export default ContactEventHistoryOverlay;
